module.exports = __webpack_public_path__ + "static/media/actor.879cd147.svg";